export const formatHumanName = (
  firstName: string | null = '',
  lastName?: string | null,
): string => {
  return [firstName, lastName].filter(Boolean).join(' ');
};

export const getUserName = (
  args:
    | {
        firstName?: string;
        lastName?: string | null;
        email?: string;
      }
    | null
    | undefined,
): string => {
  const { firstName, lastName, email } = args ?? {};

  if (firstName || lastName) {
    return formatHumanName(firstName, lastName);
  }
  return email ?? '';
};
